export const redirectToUrl = (url: string): void => {
  window.location.href = url;
};

export const redirectToNewTab = (url: string): Window | null => {
  return window.open(url, "_blank");
};
